/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import { rem, transitions } from 'polished'

import theme from 'styles/theme'
import { Title20 } from 'components/Typography'
import MarkdownRenderer from 'components/MarkdownRenderer'

const flexStyle = css`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
`

const fontStyle = css`
  font-family: SangbleuKindgdom-Light, serif;
  font-weight: 300;
`

export const Card = styled.div`
  ${flexStyle}
  justify-content: flex-start;
  position: relative;
  box-shadow: 0px 3.92px 7.84px 0px rgba(211, 218, 226, 1);
  width: 100%;
`

export const CardMedia = styled(GatsbyImage)`
  height: 220px;
  max-height: 220px;
  width: 100%;

  ${theme.mediaQueries.medium} {
    height: 182px;
    max-height: 182px;
  }
`

export const CardBody = styled.article`
  ${flexStyle}
  justify-content: flex-start;
  row-gap: ${rem(14)};
  padding: ${rem(18)};
  flex: 1;
`

export const CardHeader = styled(Title20)`
  ${fontStyle}
  width: 100%;
  text-align: center;
  font-size: ${rem(17.364)};
  font-weight: 300;
  line-height: 140%;
  letter-spacing: 0.076px;

  ${({ fullSize }) =>
    fullSize &&
    `
    font-size: ${rem(21.705)};
    letter-spacing: 0.095px;
    line-height: 140%;
  `}

  ${theme.mediaQueries.medium} {
    font-size: ${rem(17.92)};
    line-height: 140%;
    letter-spacing: 0.07px;
  }
`

export const CardContent = styled(MarkdownRenderer)`
  p {
    ${fontStyle}
    font-family: BrownStd-Light;
    color: ${theme.colors.gray};
    text-align: center;
    font-size: ${rem(10.8)};
    font-weight: 300;
    line-height: 120%;

    ${({ fullSize }) =>
      fullSize &&
      `
      font-size: ${rem(13.566)};
      line-height: 120%;
    `}

    ${theme.mediaQueries.medium} {
      font-size: ${rem(11.2)};
      line-height: 120%;
      font-weight: 300;
      margin-bottom: initial;
    }
  }
`
export const CardAction = styled.button`
  ${flexStyle}
  ${transitions('background 0.3s', 'color 0.3s')}
  border: 1px solid ${theme.colors.darkGrey};
  background: transparent;
  padding: ${rem(9)} ${rem(11)};
  font-size: ${rem(12)};
  font-weight: 400;
  font-family: BrownStd-Light, sans-serif;
  margin-top: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  column-gap: 8px;
  width: 100%;
  text-transform: uppercase;

  * path {
    ${transitions('filter 0.3s')}
  }


  &:active, &:hover {
    background: ${theme.colors.darkGrey};
    color: ${theme.colors.white};

    * path {
      filter: invert(1);
    }
  }

  ${theme.mediaQueries.medium} {
    font-size: ${rem(10)};
  }
`
